// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FefY3AGPXhEwPyGP5eEc{margin-bottom:4px}.FefY3AGPXhEwPyGP5eEc li{padding-left:20px;position:relative}.FefY3AGPXhEwPyGP5eEc li:before{content:"";border-radius:50%;width:4px;height:4px;margin:auto;position:absolute;top:3px;bottom:0;left:8px}.FefY3AGPXhEwPyGP5eEc li.NklC61Nr4MSA7OIW_107:before{background-color:var(--red-100)}.FefY3AGPXhEwPyGP5eEc li.BdoudjQgCBsSpC7xnm3c:before{background-color:var(--yellow-100)}.SPzzdTXq5U3Ze1X9Xcyz{margin-top:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `FefY3AGPXhEwPyGP5eEc`,
	"statealert": `NklC61Nr4MSA7OIW_107`,
	"statewarning": `BdoudjQgCBsSpC7xnm3c`,
	"actions": `SPzzdTXq5U3Ze1X9Xcyz`
};
export default ___CSS_LOADER_EXPORT___;
